//
//
//
//
//
//
//
//
//
//
//

import Heading from '@/components/Heading'

export default {
  components: {
    Heading
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  },

  computed: {
    id() {
      return this.$route.params.id // Current site id
    },

    tabs() {
      let path = `/billing`
      return [
        { to: `${path}/payment`, label: 'Make payment', icon: 'credit_card' },
        {
          to: `${path}/history`,
          label: 'Billing history',
          icon: 'o_request_page'
        }
      ]
    }
  }
}
